export const getPublications = [
  {
    authors: "Xiong, J., Abhishek, Guo, S., Kinouchi, T., Anjaneyulu, R.",
    year: 2024,
    title:
      " Emerging trends and spatial shifts of drought potential across global river basins.",
    journal: " Journal of Environmental Management. ",
    doi: "10.1016/j.jenvman.2024.120093",
    url: "https://doi.org/10.1016/j.jenvman.2024.120093",
  },
  {
    authors: "Xiong, J., Guo, S., Abhishek, Yin, J., Xu, C., Wang, J., Guo, J.",
    year: 2024,
    title:
      " Variation and attribution of probable maximum precipitation of China using a high-resolution dataset in a changing climate.",
    journal: " Hydrology and Earth System Sciences. ",
    doi: "10.5194/hess-28-1873-2024",
    url: "https://doi.org/10.5194/hess-28-1873-2024",
  },
  {
    authors:
      "Goswami, S., Ternikar, C. R., Kandala, R., Pillai, N. S., Yadav, V., Abhishek, Joseph, J., Ghosh, S., Vishwakarma, B. D.",
    year: 2024,
    title:
      " Water-budget based Evapotranspiration product captures natural and human-caused variability.",
    journal: " Environmental Research Letters. ",
    doi: "10.1088/1748-9326/ad63bd",
    url: "https://doi.org/10.1088/1748-9326/ad63bd",
  },
  {
    authors:
      "Xiong, J., Jiang, L., Qiu, Y., Wongchuig, S., Abhishek, Guo, S. and Chen, J.",
    year: 2023,
    title:
      " On the capabilities of the SWOT satellite to monitor the lake level change over the Third Pole.",
    journal: " Environmental Research Letters.",
    doi: "10.1088/1748-9326/acbfd1",
    url: "https://iopscience.iop.org/article/10.1088/1748-9326/acbfd1",
  },
  {
    authors:
      "Zhao, W., Abhishek, B. S. Takhellambam, Zhang, J., Zhao, Y., Kinouchi, T. ",
    year: 2023,
    title:
      " Spatiotemporal variability of current and future sub-daily rainfall in Japan using state-of-the-art high-quality datasets.",
    journal: " Water Resources Research. ",
    doi: "10.1029/2022WR034305",
    url: "https://doi.org/10.1029/2022WR034305",
  },
  {
    authors:
      "Xiong, J., Abhishek, Xu, L., Chandanpurkar, H. A., Famiglietti, J. S., Zhang, C., Ghiggi, G., Guo, S., Pan, Y., and Vishwakarma, B. D",
    year: 2023,
    title:
      " ET-WB: water-balance-based estimations of terrestrial evaporation over global land and major global basins.",
    journal: " Earth System Science Data.",
    doi: "10.5194/essd-15-4571-2023",
    url: "https://doi.org/10.5194/essd-15-4571-2023",
  },
  {
    authors: "Hitesh Supe, Abhishek, Ram Avtar",
    year: 2023,
    title:
      " Assessment of the solar energy–agriculture–water nexus in the expanding solar energy industry of India: An initiative for sustainable resource management.",
    journal: " Heliyon.",
    doi: "10.1016/j.heliyon.2023.e23125",
    url: "https://doi.org/10.1016/j.heliyon.2023.e23125",
  },
  {
    authors: "Abhishek, Kinouchi, T., Abolafia-Rosenzweig, R. and Ito, M.",
    year: 2022,
    title:
      " Water budget closure in the upper Chao Phraya River Basin, Thailand using multisource data.",
    journal: " Remote Sensing.",
    doi: "10.3390/rs14010173",
    url: "https://doi.org/10.3390/rs14010173",
  },
  {
    authors: "Zhao, W., Abhishek and Kinouchi, T.",
    year: 2022,
    title:
      " Uncertainty quantification in intensity-duration-frequency curves under climate change: Implications for flood-prone tropical cities.",
    journal: " Atmospheric Research.",
    doi: "10.1016/j.atmosres.2022.106070",
    url: "https://doi.org/10.1016/j.atmosres.2022.106070",
  },
  {
    authors: "Abhishek, and Kinouchi, T.",
    year: 2022,
    title:
      " Multidecadal Land Water and Groundwater Drought Evaluation in Peninsular India.",
    journal: " Remote Sensing.",
    doi: "10.3390/rs14061486",
    url: "https://doi.org/10.3390/rs14061486",
  },
  {
    authors: "Xiong, J., Yin, J., Guo, S., He, S., Chen, J. and Abhishek.",
    year: 2022,
    title:
      " Annual runoff coefficient variation in a changing environment: a global perspective.",
    journal: " Environmental Research Letters.",
    doi: "10.1088/1748-9326/ac62ad",
    url: "https://iopscience.iop.org/article/10.1088/1748-9326/ac62ad",
  },
  {
    authors: "Zhao, W., Abhishek, Kinouchi, T., Raksmey, A. and Zhuang, Q.",
    year: 2022,
    title:
      " Quantification of climate change impact on heavy rainfall in Cambodia: Implications for adaptation strategies.",
    journal: " Science of the Total Environment.",
    doi: "10.1016/j.scitotenv.2022.155553",
    url: "https://doi.org/10.1016/j.scitotenv.2022.155553",
  },
  {
    authors: "Xiong, J., Abhishek, Guo, S. and Kinouchi, T.",
    year: 2022,
    title:
      " Leveraging machine learning methods to quantify 50 years of dwindling groundwater in India.",
    journal: " Science of the Total Environment.",
    doi: "10.1016/j.scitotenv.2022.155474",
    url: "https://doi.org/10.1016/j.scitotenv.2022.155474",
  },
  {
    authors: "Bageshree, K., Abhishek, and Kinouchi, T.",
    year: 2022,
    title:
      " Unraveling the multiple drivers of greening- browning and leaf area variability in a socioeconomically sensitive drought-prone region.",
    journal: " Climate.",
    doi: "10.3390/cli10050070",
    url: "https://doi.org/10.3390/cli10050070",
  },
  {
    authors:
      "Xiong, J., Guo, S., Chen, D., Zhong, Y., Liu, B., Abhishek, and Yin, J.",
    year: 2022,
    title:
      " Past and future terrestrial water storage changes in the lower Mekong River basin: the influences of climatic and non-climatic factors.",
    journal: " Journal of Hydrology.",
    doi: "10.1016/j.jhydrol.2022.128275",
    url: "https://doi.org/10.1016/j.jhydrol.2022.128275",
  },
  {
    authors:
      "Xiong, J., Yin, J., Guo S., Yin, W., Rao, W., Chao, N. and Abhishek.",
    year: 2022,
    title:
      " Using GRACE to detect groundwater variation in North China Plain after south-north water diversion.",
    journal: " Groundwater.",
    doi: "10.1111/gwat.13253",
    url: "https://doi.org/10.1111/gwat.13253",
  },
  {
    authors: "Bageshree, K., Abhishek, and Kinouchi, T.",
    year: 2022,
    title:
      " A Multivariate Drought Index for Seasonal Agriculture Drought Classification in Semiarid Regions.",
    journal: " Remote Sensing. ",
    doi: "10.3390/rs14163891",
    url: "https://doi.org/10.3390/rs14163891",
  },
  {
    authors: "Xiong, J., Guo, S., Abhishek, Li, J. and Yin, J.",
    year: 2022,
    title:
      " A novel standardized drought and flood potential index based on reconstructed daily GRACE data.",
    journal: " Journal of Hydrology.",
    doi: "10.1175/JHM-D-22-0011.1",
    url: "https://doi.org/10.1175/JHM-D-22-0011.1",
  },
  {
    authors: "Xiong, J., Guo, S., Abhishek, Chen, J. and Yin, J. ",
    year: 2022,
    title:
      " Global evaluation of the “dry gets drier, and wet gets wetter” paradigm from a terrestrial water storage change perspective.",
    journal: " Hydrology and Earth System Sciences (Highlight article). ",
    doi: "10.5194/hess-26-6457-2022",
    url: "https://doi.org/10.5194/hess-26-6457-2022",
  },
  {
    authors: "Abhishek, and Kinouchi, T.",
    year: 2021,
    title:
      " Synergetic application of GRACE gravity data, global hydrological model, and in-situ observations to quantify water storage dynamics over Peninsular India during 2002-2017.",
    journal: " Journal of Hydrology.",
    doi: "10.1016/j.jhydrol.2021.126069",
    url: "https://doi.org/10.1016/j.jhydrol.2021.126069",
  },
  {
    authors: "Dass, B., Abhishek, Sen, S., Bamola, V., Sharma, A. and Sen, D.",
    year: 2021,
    title:
      " Assessment of Spring flows in Indian Himalayan Micro-Watersheds -A Hydro-geological Approach.",
    journal: " Journal of Hydrology.",
    doi: "10.1016/j.jhydrol.2021.126354",
    url: "https://doi.org/10.1016/j.jhydrol.2021.126354",
  },
  {
    authors: "Abhishek, Kinouchi, T. and Sayama, T.",
    year: 2021,
    title:
      " A comprehensive assessment of water storage dynamics and hydroclimatic extremes in the Chao Phraya River Basin during 2002-2020.",
    journal: " Journal of Hydrology.",
    doi: "10.1016/j.jhydrol.2021.126868",
    url: "https://doi.org/10.1016/j.jhydrol.2021.126868",
  },
];
